export default __webpack_public_path__ + "static/media/TF_24.b408451b.png";